import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import actionCreators from "../../actionCreators/index.js";
import TpMain from "./tpMain";

function mapStateToProps(state) {
  return {
    businessActivities: state.businessActivities,
    createTransactionResponse: state.createTransactionResponse,
    isSimulateMode: state.isSimulateMode,
    simulatedBusinessActivities: state.simulatedBusinessActivities,
    txnsForReviewCount: state.txnsForReviewCount,
    dealerAccount: state.dealerAccount,
    userDetails: state.userDetails,
    texts : state.translatedTexts,
    relatedAccount: state.relatedAccount
  };
}

function mapDispatchToProps(dispatch) {
  let actionDispatcher = bindActionCreators(actionCreators, dispatch);
  return actionDispatcher;
}

export default connect(mapStateToProps, mapDispatchToProps)(TpMain);
